import React from "react";
import { useAuth } from "../../../contexts/AuthContext";
import Spinner from "../../../components/Spinner";

const ProfilePage = () => {
  const { auth } = useAuth();
  if (!auth) {
    return (
      <>
        Loading profile
        <Spinner />
      </>
    );
  }
  return (
    <div>
      <h3 className="fw-bold">Profile</h3>
      <p className="text-muted">Your personal account information.</p>

      <div className="card p-3 shadow-sm mt-3">
        <p>
          <strong>Email:</strong> {auth.email}
        </p>
        <p>
          <strong>User ID:</strong> {auth.userId}
        </p>
        <p>
          <strong>Roles:</strong> {auth.roles?.join(", ")}
        </p>

        <p>
          <strong>First Name:</strong> {auth.firstName}
        </p>
        <p></p>
        <p>
          <strong>Phone:</strong> {auth.phone}
        </p>
      </div>
    </div>
  );
};

export default ProfilePage;
